import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const HomeFeedSwitcher = () => import(/* webpackChunkName: "4-feat-homefeed-switcher" */ './HomeFeedSwitcher');

export default lazyLoadOnRender({ loader: HomeFeedSwitcher });
